import './TrainingCard.css';

const TrainingCard = ({ training, delay = 0 }) => {
    return (
        <li
            className="theTrain shine-on-hover"
            data-aos="fade-up"
            data-aos-delay={`${delay}00`}
        >
            <h2 className="train-title">{training.title}</h2>
            {Array.isArray(training.pointsData) && (
                <ul className="train-points">
                    {training.pointsData.map((item, i) => (
                        <li className="train-point" key={i}>{item}</li>
                    ))}
                </ul>
            )}
        </li>
    );
};

export default TrainingCard;
